import * as React from "react";
import ProfileQuery from "../../queries/ProfileQuery";
import { Spin } from "antd";
import UserDetails from "src/components/UserDetails";

export default () => {
  return (
    <ProfileQuery>
      {({ loading, error, data }) => {
        if (!data) {
          return null;
        }
        if (loading) {
          return (
            <div>
              <Spin tip="Loading..." />
            </div>
          );
        }
        if (error) {
          return <h1>ERROR</h1>;
        }
        return <UserDetails admin={false} user={data.me} loading={loading} />;
      }}
    </ProfileQuery>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Profile/ProfilePage.tsx